var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"premium-photo-redirect",attrs:{"aria-live":"polite"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"#d4af37","size":"42"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }